module.exports = __webpack_public_path__ + "img/header_middle_bg1.301c2b53.png";